// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--wUfgC","eyebrow":"styles-module--eyebrow--2MF8E","heading":"styles-module--heading--1nmjI"};